import { HTTP, ENDPOINT } from "../config";
import { fetchFromLawfeed } from "../fetchFromLawfeed";

export const getOrg = async () => {
    const response = await fetchFromLawfeed({
        method: HTTP.GET,
        endpoint: ENDPOINT.getOrganization,
    });

    return response;
}